module.exports = __webpack_public_path__ + "img/upload_info.805cf627.svg";